<div class="row">
  <div class="card margin-left-14px width-802px">
    <div class="card-header wh-header header3 ">
      <div class="row">
        <div class="col-md-4">
          <label>Basic Details</label>
          <!--<a (click)="Editgeneral()" class="nav-link-hand education-navlink">
            <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
          </a>-->
          <!--<button type="button" (click)="Addgeneral()" class="btn btn-primary btn-sm nav-link-hand float-right"><i class="fas fa-plus"></i></button>-->
        </div>
        <div class="col-md-8 float-right text-align-end">
          <!--<button type="button" (click)="Addgeneral()" class="btn btn-primary btn-sm nav-link-hand"><i class="fas fa-plus"></i></button>-->
          <a (click)="Editgeneral()" class="nav-link-hand education-navlink">
            <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
          </a>
        </div>

      </div>
    </div>
    <div class="card-body padding-top-0px">
      <!--<div class="table-component">
    <div class="table-responsive">


      <table class="table table-striped margin-left-zero">

        <thead class="">
          <tr>
            <th class="">Code</th>

            <th class="">Name</th>

            <th class="">Commsn Alwd</th>
            <th class="">Mn Commsn</th>
            <th class="">MX Commsn</th>
            <th class="">Dfit Commsn</th>
            <th class="">Edtbl charg</th>
            <th class="">Refund Alwd</th>
            <th class="">Edit Aprvl Req</th>
          </tr>
        </thead>
        <tbody class="table-body">
          <tr>
            <td>1001</td>
            <td>Andrology</td>

            <td>Yes</td>
            <td>100</td>
            <td>100</td>
            <td>100</td>
            <td>100</td>






          </tr>

        </tbody>

      </table>
    </div>
  </div>-->
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-2 padding-right-0px text-align-left">
              <label for="firstName">Code </label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>1001</label>
            </div>
            <div class="col-md-3 offset-md-1 padding-right-0px text-align-left">
              <label for="firstName">Service Category </label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>Andrology</label>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-2 padding-right-0px text-align-left">
              <label for="firstName">Name </label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>InnamuriPavan</label>
            </div>
            <div class="col-md-3 offset-md-1 padding-right-0px text-align-left">
              <label for="firstName">Revenue Category </label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>Others</label>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-2 padding-right-0px text-align-left">
              <label for="firstName">Tax(%) </label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>10</label>
            </div>
            <div class="col-md-3 offset-md-1 padding-right-0px text-align-left">
              <label for="firstName">Default Commission </label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>100</label>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-2 padding-right-0px text-align-left">
              <label for="firstName">Service Type </label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>Procedure</label>
            </div>
            <div class="col-md-3 offset-md-1 padding-right-0px text-align-left">
              <label for="firstName">Minimum Commission </label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>100</label>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-2 padding-right-0px text-align-left">
              <label for="firstName">UOM</label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>100</label>
            </div>
            <div class="col-md-3 offset-md-1 padding-right-0px text-align-left">
              <label for="firstName">Maximum Commission </label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>100</label>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-2 padding-right-0px text-align-left">
              <label for="firstName">Note</label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>100</label>
            </div>
            <div class="col-md-3 offset-md-1 padding-right-0px text-align-left">
              <label for="firstName">Max Discount Allowed </label>
            </div>:
            <div class="col-md-2 text-align-right">


              <label>100</label>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>
